var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"bbe-color-palette"},_vm._l((_vm.colorPalette),function(color,index){return _c('div',{key:color,staticClass:"bbe-color-palette__item",class:{
         'bbe-color-palette__item_active': _vm.checkedColor(color),
         'bbe-color-palette__item_first': index < 16
       },style:({backgroundColor: color}),attrs:{"value":color},on:{"click":function($event){return _vm.setColor(color)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3760fed7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/TextEditor/ColorPalette/ColorPalette.vue
// module id = null
// module chunks = 